if (!customElements.get('product-bundle-builder')) {
  class ProductBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
      this.selected = new Map();
this.defaultCategoryImages = new Map();
this.defaultCategoryTitles = new Map();

this.querySelectorAll('[data-category]').forEach((row) => {
  const imageContainer = row.querySelector('[data-category-image]');

  this.defaultCategoryImages.set(
    row.dataset.category,
    imageContainer ? imageContainer.innerHTML : ''
  );

  this.defaultCategoryTitles.set(
    row.dataset.category,
    row.querySelector('[data-category-title]')?.textContent.trim() || ''
  );
});

this.dialog = this.querySelector('[data-bundle-dialog]');
      this.addButton = this.querySelector('[data-add-bundle]');
      this.message = this.querySelector('[data-bundle-message]');
      this.bindEvents();
      this.syncCurrentVariant();
      this.variantObserver = new MutationObserver(() => this.syncCurrentVariant());
      const form = this.getProductForm();

      this.handleProductFormChange = (event) => {
        if (event.target.matches('[name="id"], [name="quantity"]')) {
          this.syncCurrentVariant();
        }
      };

      if (form) {
        this.productForm = form;
        this.variantObserver.observe(form, {
          subtree: true,
          attributes: true,
          childList: true
        });
        form.addEventListener('input', this.handleProductFormChange);
        form.addEventListener('change', this.handleProductFormChange);
      }
    }

    disconnectedCallback() {
      this.variantObserver?.disconnect();

      if (this.productForm && this.handleProductFormChange) {
        this.productForm.removeEventListener(
          'input',
          this.handleProductFormChange
        );
        this.productForm.removeEventListener(
          'change',
          this.handleProductFormChange
        );
      }
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const open = event.target.closest('[data-open-category]');
const remove = event.target.closest('[data-remove-category]');
const select = event.target.closest('[data-select-product]');
const review = event.target.closest('[data-review-bundle]');
const removeSelected = event.target.closest(
  '[data-remove-selected-product]'
);

if (open) this.openCategory(open.dataset.openCategory);
if (remove) this.removeCategory(remove.dataset.removeCategory);
if (select) this.selectProduct(select);
if (review) this.dialog.close();

if (removeSelected) {
  this.removeSelectedProduct(removeSelected);
}
      });
      this.querySelector('[data-close-dialog]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('click', (event) => {
  if (event.target === this.dialog) {
    this.dialog.close();
  }
});

this.dialog?.addEventListener('close', () => {
  document.documentElement.classList.remove('bundle-dialog-open');
});
      this.querySelectorAll('[data-card-variant]').forEach((select) => {
        select.addEventListener('change', () => {
  const option = select.selectedOptions[0];
  const card = select.closest('.bundle-builder__card');
  const price = card.querySelector('[data-card-price]');
  const image = card.querySelector('.bundle-builder__card-image img');

  price.textContent = option.dataset.priceFormatted;

  if (image && option.dataset.image) {
  image.src = option.dataset.image;
  image.removeAttribute('srcset');
}

const addButton = card.querySelector('[data-select-product]');
const key = `${addButton.dataset.categoryIndex}:${addButton.dataset.productId}`;

if (this.selected.has(key)) {
  const item = this.selected.get(key);

  item.id = option.value;
  item.price = Number(option.dataset.price);
  item.compareAtPrice = Number(option.dataset.compareAtPrice) || 0;
  item.variant = option.textContent.trim();
  item.image = option.dataset.image;

  this.selected.set(key, item);
  this.renderCategory(addButton.dataset.categoryIndex);
  this.updateTotal();
}
});
      });
      this.querySelectorAll('[data-card-quantity]').forEach((input) => {
        input.addEventListener('input', () => this.updateItemQuantity(input));
        input.addEventListener('change', () => this.updateItemQuantity(input));
      });
      this.addButton?.addEventListener('click', () => this.addBundle());
    }

    getProductForm() {
      const section = this.closest('.shopify-section') || document;
      return section.querySelector('product-form form, form[action*="/cart/add"]');
    }

    getCurrentVariantId() {
      return this.getProductForm()?.querySelector('[name="id"]')?.value || null;
    }

    syncCurrentVariant() {
      const input = this.getProductForm()?.querySelector('[name="id"]');
      if (!input) return;
      const variant = this.config.currentVariants?.[input.value];
      if (variant) {
        this.config.currentPrice = variant.price;
        this.config.currentCompareAtPrice =
          Number(variant.compareAtPrice) || 0;
        this.querySelector('[data-current-price]').textContent = variant.priceFormatted;
        this.querySelector('[data-current-variant-title]').textContent = variant.title;
      }
      this.updateTotal();
    }

    openCategory(index) {
  let activeGrid = null;

  this.querySelectorAll('[data-product-grid]').forEach((grid) => {
    const isActive = grid.dataset.productGrid === index;
    grid.hidden = !isActive;

    if (isActive) {
      activeGrid = grid;
    }
  });

  const row = this.querySelector(`[data-category="${index}"]`);

  this.querySelector('[data-dialog-title]').textContent =
    `Choose ${row.querySelector('[data-category-title]').textContent.trim()}`;

  this.dialog.dataset.productCount =
    activeGrid?.dataset.productCount || '1';

  document.documentElement.classList.add('bundle-dialog-open');
this.dialog.showModal();
}

    selectProduct(button) {
  if (button.disabled) return;

  const card = button.closest('.bundle-builder__card');
  const select = card?.querySelector('[data-card-variant]');
  const option = select?.selectedOptions[0];

  if (!card || !select || !option || option.disabled) return;

  const category = button.dataset.categoryIndex;
  const productId = button.dataset.productId;
  const key = `${category}:${productId}`;

  if (this.selected.has(key)) return;

  const quantityInput = card.querySelector('[data-card-quantity]');
  const quantity = Math.max(1, Number(quantityInput?.value) || 1);

  this.selected.set(key, {
    id: option.value,
    productId,
    category,
    price: Number(option.dataset.price),
    compareAtPrice: Number(option.dataset.compareAtPrice) || 0,
    quantity,
    title: button.dataset.productTitle,
    variant: option.textContent.trim(),
    image: option.dataset.image
  });

  card.classList.add('is-selected');

  button.classList.add('is-added');
  button.textContent = 'Added';
  button.setAttribute('aria-pressed', 'true');

  const removeButton = card.querySelector(
    '[data-remove-selected-product]'
  );

  if (removeButton) {
    removeButton.hidden = false;
  }

  this.renderCategory(category);
  this.updateReviewBar();
  this.updateTotal();
}

    updateItemQuantity(input) {
      const card = input.closest('.bundle-builder__card');
      const button = card?.querySelector('[data-select-product]');
      if (!button) return;

      const key = `${button.dataset.categoryIndex}:${button.dataset.productId}`;
      const quantity = Math.max(1, Number(input.value) || 1);
      input.value = String(quantity);

      if (!this.selected.has(key)) return;

      const item = this.selected.get(key);
      item.quantity = quantity;
      this.selected.set(key, item);

      this.renderCategory(item.category);
      this.updateReviewBar();
      this.updateTotal();
    }

    removeSelectedProduct(removeButton) {
  const category = removeButton.dataset.categoryIndex;
  const productId = removeButton.dataset.productId;
  const key = `${category}:${productId}`;
  const card = removeButton.closest('.bundle-builder__card');
  const addButton = card.querySelector('[data-select-product]');

  this.selected.delete(key);

  card.classList.remove('is-selected');
  removeButton.hidden = true;

  addButton.classList.remove('is-added');
  addButton.textContent = 'Add';
  addButton.setAttribute('aria-pressed', 'false');

  this.renderCategory(category);
  this.updateReviewBar();
  this.updateTotal();
}

removeCategory(index) {
  this.selected.forEach((item, key) => {
    if (item.category === index) {
      this.selected.delete(key);
    }
  });

  this.querySelectorAll(
    `[data-bundle-card][data-category-index="${index}"]`
  ).forEach((card) => {
    const addButton = card.querySelector('[data-select-product]');
    const removeButton = card.querySelector(
      '[data-remove-selected-product]'
    );

    card.classList.remove('is-selected');

    if (addButton) {
      addButton.classList.remove('is-added');
      addButton.textContent = 'Add';
      addButton.setAttribute('aria-pressed', 'false');
    }

    if (removeButton) {
      removeButton.hidden = true;
    }
  });

  this.renderCategory(index);
  this.updateReviewBar();
  this.updateTotal();
}

    renderCategory(index) {
  const row = this.querySelector(`[data-category="${index}"]`);

  const items = [...this.selected.values()].filter(
    (item) => item.category === index
  );

  const title = row.querySelector('[data-category-title]');
  const status = row.querySelector('[data-category-status]');
  const price = row.querySelector('[data-category-price]');
  const openButton = row.querySelector('[data-open-category]');
  const removeButton = row.querySelector('[data-remove-category]');
  const imageContainer = row.querySelector('[data-category-image]');

  const originalTitle =
    this.defaultCategoryTitles.get(String(index)) || '';

  if (items.length === 0) {
    title.textContent = originalTitle;
    status.textContent = this.config.labels.choose;
    price.hidden = true;

    openButton.hidden = false;
    openButton.textContent = '+';
    openButton.classList.remove('is-selected');
    openButton.setAttribute('aria-label', 'Choose products');

    removeButton.hidden = true;

    row.classList.remove('has-multiple-products');

    imageContainer.classList.remove(
      'has-selected-product',
      'has-selected-products'
    );

    imageContainer.innerHTML =
      this.defaultCategoryImages.get(String(index)) || '';

    return;
  }

  const categoryTotal = items.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  price.textContent = this.formatMoney(categoryTotal);
  price.hidden = false;

  /* Only one selected product: show full product details */
  if (items.length === 1) {
    const item = items[0];

    title.textContent = item.title;
    status.textContent = item.quantity > 1
      ? `${item.variant} · Qty ${item.quantity}`
      : item.variant;

    row.classList.remove('has-multiple-products');

    imageContainer.classList.remove('has-selected-products');
    imageContainer.classList.add('has-selected-product');

    imageContainer.innerHTML = item.image
      ? `<img
          src="${item.image}"
          alt=""
          loading="lazy"
        >`
      : '';

    openButton.hidden = true;
    openButton.classList.remove('is-selected');

    removeButton.hidden = false;
    removeButton.textContent = '×';
    removeButton.setAttribute(
      'aria-label',
      `Remove ${item.title}`
    );

    return;
  }

  /* Multiple selected products: show category summary */
  const categoryQuantity = items.reduce(
    (total, item) => total + item.quantity,
    0
  );

  title.textContent = originalTitle;
  status.textContent = `${categoryQuantity} Products Selected`;

  row.classList.add('has-multiple-products');

  openButton.hidden = false;
  openButton.textContent = '⋮';
  openButton.classList.add('is-selected');
  openButton.setAttribute(
    'aria-label',
    'Review selected products'
  );

  removeButton.hidden = true;

  const imageItems = items
    .filter((item) => item.image)
    .slice(0, 3);

  imageContainer.classList.remove('has-selected-product');
  imageContainer.classList.add('has-selected-products');

  imageContainer.innerHTML = imageItems
    .map(
      (item, position) =>
        `<img
          src="${item.image}"
          alt=""
          loading="lazy"
          class="bundle-builder__stacked-image bundle-builder__stacked-image--${position + 1}"
        >`
    )
    .join('');
}
updateReviewBar() {
  const reviewBar = this.querySelector('[data-review-bar]');
  const reviewCount = this.querySelector('[data-review-count]');

  if (!reviewBar || !reviewCount) return;

  const selectedCount = [...this.selected.values()].reduce(
    (total, item) => total + item.quantity,
    0
  );

  reviewCount.textContent = selectedCount;
reviewBar.hidden = false;
reviewBar.classList.toggle('is-empty', selectedCount === 0);
}

updateTotal() {
  const quantityInput =
    this.getProductForm()?.querySelector('[name="quantity"]');

  const currentQuantity =
    Math.max(1, Number(quantityInput?.value) || 1);

  const currentPrice =
    Number(this.config.currentPrice) || 0;

  const currentCompareAtPrice =
    Number(this.config.currentCompareAtPrice) || 0;

  const currentLineTotal =
    currentPrice * currentQuantity;

  const currentIsSale =
    currentCompareAtPrice > currentPrice;

  let total = currentLineTotal;
  let eligibleTotal = currentIsSale ? 0 : currentLineTotal;
  let excludedSaleTotal = currentIsSale ? currentLineTotal : 0;
  let eligibleQuantity = currentIsSale ? 0 : currentQuantity;

  this.selected.forEach((item) => {
    const lineTotal = item.price * item.quantity;
    const compareAtPrice = Number(item.compareAtPrice) || 0;
    const isSaleProduct = compareAtPrice > item.price;

    total += lineTotal;

    if (isSaleProduct) {
      excludedSaleTotal += lineTotal;
    } else {
      eligibleTotal += lineTotal;
      eligibleQuantity += item.quantity;
    }
  });

  let discountPercent = 0;

  if (eligibleQuantity >= 4) {
    discountPercent = 10;
  } else if (eligibleQuantity >= 2) {
    discountPercent = 5;
  }

  const discountedEligibleTotal = Math.round(
    eligibleTotal * (1 - discountPercent / 100)
  );

  const finalTotal =
    excludedSaleTotal + discountedEligibleTotal;

  const actualSaving = total - finalTotal;
  const hasBundleDiscount = actualSaving > 0;

  const finalPrice =
    this.querySelector('[data-bundle-total]');

  const originalPrice =
    this.querySelector('[data-bundle-original-total]');

  if (finalPrice) {
    finalPrice.textContent = this.formatMoney(finalTotal);
  }

  if (originalPrice) {
    originalPrice.textContent = this.formatMoney(total);
    originalPrice.hidden = !hasBundleDiscount;
  }

  const currentVariantId = this.getCurrentVariantId();
const currentVariant =
  this.config.currentVariants?.[currentVariantId];

this.addButton.disabled =
  this.selected.size === 0 ||
  !currentVariantId ||
  !currentVariant?.available;
}

    formatMoney(cents) {
      return new Intl.NumberFormat(this.config.locale || 'en-GB', { style: 'currency', currency: this.config.currency || 'GBP' }).format(cents / 100);
    }

    async addBundle() {
      const currentId = this.getCurrentVariantId();
      const currentVariant =
        this.config.currentVariants?.[currentId];

      if (
        !currentId ||
        !currentVariant?.available ||
        this.selected.size === 0
      ) {
        this.updateTotal();
        return;
      }
      const quantityInput = this.getProductForm()?.querySelector('[name="quantity"]');
      const items = [{ id: Number(currentId), quantity: Math.max(1, Number(quantityInput?.value) || 1) }];
      this.selected.forEach((item) => items.push({ id: Number(item.id), quantity: item.quantity }));
      this.classList.add('is-loading');
      this.addButton.disabled = true;
      this.message.hidden = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Cart error');
        this.message.textContent = this.config.labels.added;
        this.message.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: result, source: 'bundle-builder' } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (error) {
        this.message.textContent =
          error.message || this.config.labels.error;
        this.message.hidden = false;
      } finally {
        this.classList.remove('is-loading');
        this.updateTotal();
      }
    }
  }

  customElements.define(
    'product-bundle-builder',
    ProductBundleBuilder
  );
}
